interface ResourceLinkProps {
  title: string;
  url: string;
  source: string;
}

export function ResourceLink({ title, url, source }: ResourceLinkProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center justify-between gap-4 px-4 py-3 rounded transition-colors"
      style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <span className="shrink-0 text-[11px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider whitespace-nowrap" style={{ color: 'var(--text-tertiary)', border: '1px solid var(--outline-variant)', backgroundColor: 'var(--surface-container-low)' }}>
          {source}
        </span>
        <span className="text-[14px] truncate transition-colors" style={{ color: 'var(--text-secondary)' }}>
          {title}
        </span>
      </div>
      <span className="material-symbols-outlined text-[18px] text-[#0078d4] shrink-0 transition-colors">
        open_in_new
      </span>
    </a>
  );
}
